import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "DataConnected"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M22.5 22.5H18V21H21V3H18V1.5H22.5V22.5ZM16.6875 12.2625C17.7114 12.6955 18.4572 13.6039 18.6825 14.6925C18.7724 15.1431 18.7724 15.6069 18.6825 16.0575C18.4572 17.1461 17.7114 18.0546 16.6875 18.4875C15.8475 18.8375 14.9025 18.8375 14.0625 18.4875C13.0386 18.0546 12.2927 17.1461 12.0675 16.0575C11.8935 15.2044 12.0576 14.3171 12.525 13.5825L10.4175 11.475C8.95425 12.3995 7.02993 12.0762 5.9491 10.7244C4.86828 9.37252 4.97648 7.42424 6.20034 6.20037C7.42421 4.97651 9.37249 4.86831 10.7243 5.94913C12.0762 7.02996 12.3995 8.95428 11.475 10.4175L13.5825 12.525C13.7358 12.4258 13.8962 12.3381 14.0625 12.2625C14.9025 11.9125 15.8475 11.9125 16.6875 12.2625ZM6.75 8.625C6.75 9.66053 7.58947 10.5 8.625 10.5C9.12228 10.5 9.59919 10.3025 9.95082 9.95082C10.3025 9.59919 10.5 9.12228 10.5 8.625C10.5 7.58947 9.66053 6.75 8.625 6.75C7.58947 6.75 6.75 7.58947 6.75 8.625ZM6 22.5H1.5V1.5H6V3H3V21H6V22.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/DataConnected.vue"]]);
